export const isUSDStableToken = (tokenName: string) => [
  'BUSD',
  'USDT',
  'USDC',
].includes(tokenName.toUpperCase())